
import { Vue, Component } from 'nuxt-property-decorator'
import ApplicationErrorAlert from '~/components/ApplicationErrorAlert.vue'
import DevMark from '~/components/DevMark.vue'

@Component({ components: { DevMark, ApplicationErrorAlert } })
export default class LoginLayout extends Vue {}
